import { render, staticRenderFns } from "./Bitway.vue?vue&type=template&id=faf13af2&"
import script from "./Bitway.vue?vue&type=script&lang=js&"
export * from "./Bitway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports